/* src/app/modules/taxes/taxes-tabs.component.scss */
:root {
  --cf-brand: #e3fd64;
  --cf-brand-dark: #4d7a00;
  --cf-brand-light: #f9ffe0;
  --cf-chrome: #1d2530;
  --cf-bg: #f4f6f8;
  --cf-surface: #ffffff;
  --cf-surface-hover: #f9fafc;
  --cf-text: #1a1d23;
  --cf-text-muted: #6b7280;
  --cf-text-on-dark: rgba(255, 255, 255, 0.87);
  --cf-border: #e5e7eb;
  --cf-border-strong: #d1d5db;
  --cf-radius: 8px;
  --cf-radius-sm: 4px;
  --cf-radius-lg: 12px;
  --cf-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  --cf-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --cf-success: #16a34a;
  --cf-warning: #d97706;
  --cf-error: #dc2626;
}
.nav,
.nav-link {
  display: inline-block;
}
nav a {
  height: 48px;
  padding: 0 24px;
  cursor: pointer;
  box-sizing: border-box;
  opacity: 0.6;
  min-width: 160px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  position: relative;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
}
.custom-link:hover {
  border-color: var(--cf-brand);
  color: black;
  opacity: 1;
  border-bottom: 3px solid var(--cf-brand);
  cursor: pointer;
}
.custom-link.active {
  border-color: var(--cf-brand);
  color: black;
  opacity: 1;
  border-bottom: 3px solid var(--cf-brand);
  cursor: pointer;
}
/*# sourceMappingURL=taxes-tabs.component.css.map */
